<template>
  <div class="fill-height">


    <v-card class="fill-height">

      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
           مدیریت کاربران
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>


      <v-card-text>
        <v-spacer/>
        <v-row>
          <v-col
              cols="12"
              sm="6"
              md="4">

            <v-autocomplete
                :items="items"
                v-model="buildingId"
                @input="handleInput"
                dense
                outlined
                :error-messages="getError('buildingId')"
                auto-select-first  append-icon="fas fa-angle-down"
                label="انتخاب مجتمع"

            />

          </v-col>
          <v-col
              cols="12"
              sm="6"
              md="4">
            <v-text-field   v-model="unitName" outlined dense placeholder="نام واحد"/>
          </v-col>
        </v-row>

        <v-col
            cols="12"
            sm="6"
            md="4" v-if="can('managementUser')" class="d-inline-block">
          <v-btn block color="#ffbf00" @click="getUserList(buildingId)">کاربران</v-btn>
        </v-col>
        <v-col
            cols="12"
            sm="6"
            md="4" v-if="can('managementUser')" class="d-inline-block">
          <v-btn block color="#0080ff"  @click="getManagerList(buildingId)">مدیران ساختمان</v-btn>
        </v-col>

        <v-spacer/>
        <br/>
        <v-row>
          <v-col cols="12"
                 sm="12">
            <b-pagination
                v-model="skip"
                :total-rows="paging.totalSize"
                :per-page=take
                first-text="اولین"
                prev-text="<"
                next-text=">"
                last-text="آخرین"
                dir="ltr"
                limit="5"
                @change="pageChangeHandler"
            />

          </v-col>
        </v-row>

        <b-table
            v-if="can('managementUser')"
            :items="dataItems"
            :fields="columns"
            :current-page="skip"
            :per-page=0
            stacked="md"
            show-empty
            responsive striped>

        </b-table>


      </v-card-text>
    </v-card>
    <create-user :model-items="model" :is-edit="true" :dialogStatus.sync="showUser"/>
    <create-manager :model-items="model"  :dialogStatus.sync="showManager"/>
  </div>
</template>

<script>
import CreateUser from '../establishment/PageEdit'
import CreateManager from '../manager/PageEdit'
import User_se from "../establishment/Unit_se";
import Manager_se from "../manager/Manager_se";
import ListBox from "../../../components/listBox/ListBox";
import {mapMutations} from "vuex";
export default {
  components: {
    CreateUser,
    CreateManager
  },
  name: 'Manager',

  data() {
    return {
      modelId: '',
      buildingId: '',
      unitName: '',
      model: {},
      items: [],
      bindingErrors: [],
      showUser: false,
      showManager: false,
      type: '',
      modelAtributes: {},
      dataItems: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        {key: 'personName', label: 'نام شخص', sortable: true, sortDirection: 'desc'},
        {key: 'mobile', label: 'موبایل ', sortable: true, sortDirection: 'desc'},
        {key: 'unitName', label: 'نام واحد', sortable: true, sortDirection: 'desc'},
        {key: 'buildingName', label: 'نام مجتمع ', sortable: true, sortDirection: 'desc'},
        // {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  methods: {

    close(){
      this.dataItems=[]
      this.unitName=''
      this.buildingId=''
      this.$router.push('/home')
    },

    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),


    pageChangeHandler: function (event) {
      this.skip = event;
      if(this.type.includes('user')) {
        this.getUserList(this.buildingId);
      } else if(this.type.includes('manager')){
        this.getManagerList(this.buildingId);
}

    },
    // fetch() {
    //   if(this.type.includes('user')){
    //   User_se.getById(this.modelId).then(response => {
    //     this.model = response.data
    //   })
    //   this.showUser = true;
    //   }else if(this.type.includes('manager')){
    //     Manager_se.getById(this.modelId).then(response => {
    //       this.model = response.data
    //     })
    //     this.showManager = true;
    //   }
    // },
    // forEdit: function (e) {
    //   this.modelId = e.id;
    //   alert(this.modelId)
    //   this.fetch()
    // },

    handleInput (value) {
      this.$emit('input', value)
    },

    getBuildingList(){
      ListBox.buildingList().then(response=>{
        this.items=response.data
      })
    },

    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find( ({ fieldName }) => fieldName === key );
        if(error && error.message ) return  error.message[0]
      }
      return ''
    },

    getUserList(buildingId) {
      this.type="user"
      this.dataItems=[]
      this.bindingErrors=[]
      this.$progress({message: 'درحال جستجو...'}, true)
      this.modelAtributes = (User_se.getUserList(this.skip - 1, this.take,buildingId,this.unitName).then(response => {
        if (response && response.status === 200) {
          this.$root.$emit('Progress')
          this.dataItems = response.data.userList
          this.paging = response.data.page
        }else if (response && response.response.status === 400) {
          this.$root.$emit('Progress')
          this.bindingErrors = response.response.data;
        }
      }));
    },

    getManagerList(buildingId) {
      this.type="manager"
      this.bindingErrors=[]
      this.$progress({message: 'درحال جستجو...'}, true)
      this.dataItems=[]
      this.modelAtributes = (Manager_se.getManagerList(this.skip - 1, this.take,buildingId,this.unitName).then(response => {
        if (response && response.status === 200) {
        this.$root.$emit('Progress')
        this.modelAtributes = response.data
        this.dataItems = this.modelAtributes.managerList
        this.paging = this.modelAtributes.page
        }else if (response && response.response.status === 400) {
          this.$root.$emit('Progress')
          this.bindingErrors = response.response.data;
        }
      }));
    },


  },

  mounted() {
    this.$root.$on('ManagementUser', () => {
      this.getUserList(this.buildingId)
    })
    this.$root.$on('ManagementManager', () => {
      this.getManagerList(this.buildingId)
    })

  },

created() {
  this.setDrawer(false)
    this.getBuildingList();
}

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
